import {
    Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { DialogProps } from '@mui/material/Dialog/Dialog';
import { isValidFunction } from '../../utils/nullChecks';

type ExcludeProps = 'onClose';
type Props = Omit<DialogProps, ExcludeProps> & {
    title: string,
    titleIcon?: React.ReactNode,
    dialogActions?: React.ReactNode,
    disableCloseIcon?: boolean,
    onClose: Function,
};

const DialogComponent = (props: Props) => {
    const {
        title,
        dialogActions,
        children,
        disableCloseIcon,
        onClose,
        titleIcon,
        ...dialogProps
    } = props;

    const handleClose = (event: React.MouseEvent<HTMLButtonElement>, reason?: string) => {
        console.log(event, reason);
        if (isValidFunction(onClose)) {
            onClose();
        }
    };

    return (
        <Dialog
            onClose={handleClose}
            {...dialogProps}
        >
            <DialogTitle
                component={Grid}
                style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}
            >
                <Grid item container alignItems="center">
                    {titleIcon}
                    {titleIcon && <>&nbsp;</>}
                    <Grid item sm={10}>
                        {title}
                    </Grid>
                </Grid>
                {
                    !disableCloseIcon && (
                        <IconButton onClick={handleClose}>
                            <CloseIcon htmlColor="black" />
                        </IconButton>
                    )
                }
            </DialogTitle>
            <DialogContent>
                <div style={{ marginTop: '1rem' }}>
                    {children}
                </div>
            </DialogContent>
            <DialogActions>
                {dialogActions}
            </DialogActions>
        </Dialog>
    );
};
DialogComponent.defaultProps = {
    dialogActions: null,
    disableCloseIcon: false,
    titleIcon: null,
};
export default DialogComponent;
